import React from 'react';
import styles from './FieldLoader.module.css';

interface FieldLoaderProps {
  className?: string;
  style?: React.CSSProperties;
}

const FieldLoader: React.FC<FieldLoaderProps> = ({ 
  className = '', 
  style = {} 
}) => {
  return (
    <svg 
      width="14" 
      height="14" 
      viewBox="0 0 24 24" 
      fill="none" 
      className={`${styles.fieldLoader} ${className}`.trim()}
      style={style}
    >
      <circle
        className={styles.opacity25}
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <path
        className={styles.opacity75}
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
};

export default FieldLoader;
